import React from 'react';

const SendUserBox = ({data}) => {
  return <div className="my-[5px] text-[12px] px-[15px] py-[5px] rounded-[12px] text-primary bg-second w-fit max-w-[85%] self-end text-right">
    {data}
  </div>;
};

export default SendUserBox;